import { MDBIcon } from 'mdb-react-ui-kit';
import { useContext } from "react";
import useResumeHobbiesHandlers from "../../../context/resume/hooks/resume-hobbies-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";

export default function HobbiesPreview() {

    const { translations } = useContext(TranslationContext);
    const { isManagerRole } = useCurrentUserRoles();
    const { isAlcyone } = useResumeProperties();
    const { hobbies } = useResumeDocumentSection();
    const { handleRemove } = useResumeHobbiesHandlers();

    return (
        <div className="d-flex flex-wrap gap-2" style={ { maxWidth: "100%" } }>
            { hobbies.map( ( hobby, index ) => (
                <div key={ index } className="d-flex align-items-center">
                    {/* Conteneur de l'icône, qu'elle soit présente ou non, pour garder l'espacement constant */ }
                    <div style={ { width: "20px", display: "flex", justifyContent: "center" } }>
                        { isManagerRole && (
                            <MDBIcon
                                far
                                icon="trash-alt"
                                style={ {
                                    color: isAlcyone ? "#09B4BF" : "#0B86C8",
                                    fontSize: "11px",
                                    cursor: "pointer",
                                    fontWeight: 'bold'
                                } }
                                onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemove( hobby ) }
                                role="button"
                                size="lg"
                            />
                        ) }
                    </div>
                    <span className="text-black" style={ { fontSize: "12px" } }>
                        { hobby.text }
                        { index < hobbies.length - 1 && ", " }
                    </span>
                </div>
            ) ) }
        </div>
    );
}
